var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"my-1",attrs:{"type":_vm.messageType ?? 'warning',"dense":"","outlined":"","border":"left","dismissible":_vm.dismissible ?? false}},[_vm._v(_vm._s(_vm.messageText))])
}
var staticRenderFns = []

export { render, staticRenderFns }